import { render, staticRenderFns } from "./templeteManage.vue?vue&type=template&id=4c1f706f&scoped=true&"
import script from "./templeteManage.vue?vue&type=script&lang=js&"
export * from "./templeteManage.vue?vue&type=script&lang=js&"
import style0 from "./templeteManage.vue?vue&type=style&index=0&id=4c1f706f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f706f",
  null
  
)

export default component.exports